import { render, staticRenderFns } from "./CustomFormFilesElement.vue?vue&type=template&id=484120b1"
import script from "./CustomFormFilesElement.vue?vue&type=script&lang=js"
export * from "./CustomFormFilesElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports